import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ILoginRes, IPerfilamiento } from 'src/app/interfaces/usuarios';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { UsuariosService } from 'src/app/services/usuarios/usuarios.service';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  formLogin = this.formBuilder.group({
    username: ['emaliqueo@duoc.cl', [Validators.required]]
  })
  devLocal: boolean = environment.devLocal

  constructor (
    private formBuilder: FormBuilder,
    private router: Router,
    private _perfilamiento: PerfilamientoService,
    private _usuarios: UsuariosService
  ) {

  }

  ngOnInit(): void {
    const token = this._usuarios.getToken()
    if ( token ) {
      this.router.navigateByUrl('/view-inicio')
    } else {
      localStorage.clear()
      if ( !this.devLocal ) {
        window.location.href = environment.loginUrl
      }
    }
  }

  fnSetDataUser(res: IPerfilamiento): void {
    if ( res.usuario ) {
      this._perfilamiento.setUsuario(res.usuario)
    }
    if ( res.menuUsuario ) {
      this._perfilamiento.setMenu(res.menuUsuario)
    }
  }

  submit() {
    localStorage.clear()
    const username: string = this.formLogin.value.username ?? ''
    this._usuarios.fakeLogin({accessToken: username}).subscribe(
      (res: ILoginRes) => {
        if ( res.error === null ) {
          this._usuarios.setToken(res.token)
          this._perfilamiento.getPerfilamiento().subscribe(
            (res: IPerfilamiento) => {
              this.fnSetDataUser(res)
              if (res.usuario.tipoUsuario == 'Docente') {
                this.router.navigate(['/portal-calificacion']);
              } else {
                this.router.navigate(['/view-inicio'])
              }
            }
          )
        } else {
          this.router.navigate(['/sin-acceso'])
        }
      }, (err: any) => {
        this.router.navigate(['/sin-acceso'])
      }
    )
  }

  accesoRapidoUsr(username: string) {
    this.formLogin.setValue({username: username})
    this.submit()
  }
}
